import React, { useCallback, useEffect, useState } from "react";
import "../assets/css/mainpage.css";
import Table from "../components/table/Table";
import MenuOptions from "../components/threeDots/Menu";
import Alert from "../components/alert";
import { useHistory } from "react-router-dom";
import config from "../api/config";
import { setToast } from "../redux/actions/ToastAction";
import { useDispatch } from "react-redux";
import AlertDialog from "../components/Modal";
// table data
const headData = ["Наименование", "Категория", "Автор"];
const renderHead = (item, index) => <th key={index}>{item}</th>;
//
// starting component
const Main = () => {

  const [url] = useState("/api/advertising/v1/byRole");
  const [total, setTotal] = useState(0);
  const [currpage, setCurrPage] = useState(0);
  const [, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [ads, setAds] = useState([]);
  // delete
  const [modal, setModal] = useState(false);
  const [deleteID, setDeleteID] = useState(0);
  // repost

  const navigate = useHistory();

  const dispatch = useDispatch();
  // page handler
  const pageHandler = (page) => {
    setLoading(true);
    setPage(page);

    config
      .get(`${url}?page=${page}`)
      .then((data) => {
        setLoading(false);

        setAds(data.data.objectKoinot.content);
        setTotal(data.data.objectKoinot.totalPages);
        setCurrPage(data.data.objectKoinot.number);
      })
      .catch((err) => {
        console.error(err?.message);
        setLoading(false);
      });

  };
  const getAllPosts = useCallback(() => {
    setLoading(true);
    config
      .get(url)
      .then((data) => {
        setLoading(false);
        setAds(data.data.objectKoinot.content);
        setTotal(data.data.objectKoinot.totalPages);
        setCurrPage(data.data.objectKoinot.number);
      })
      .catch((err) => console.error(err?.message));
  }, [url]);

  useEffect(() => {
    getAllPosts();
  }, [getAllPosts]);
  const deleteHandler = async (bool) => {
    if (bool) {
      try {
        await config.delete(`/api/advertising/v1/${deleteID}`, deleteID);
        dispatch(setToast(true, "success", "Успешно удалено"));
        // setImageView(true);
      } catch (err) {
        dispatch(
          setToast(
            true,
            "error",
            "Произошла ошибка, проверьте подключение к Интернету и повторите попытку."
          )
        );
      }
      getAllPosts();
    }
  };

  // menu data
  const renderBody = (item, index) => (
    <tr key={index}>
      <td>{item.name}</td>
      <td> {item.category ? item.category.nameRu : "User type"} </td>
      <td>
        {item.user?.firstName} {item.user?.lastName}
      </td>
      <td>
        <MenuOptions
          options={[
            {
              value: "Изменять",
              callback: () => {
                navigate.push({
                  pathname: `/post_ad`,
                  data: item,
                });
              },
            },
            {
              value: "Удалить",
              callback: () => {
                setDeleteID(item.id);
                setModal(true);
              },
            },
          ]}
        />
      </td>
    </tr>
  );

  return (
    <div className="">
      <AlertDialog
        text="Вы действительно хотите удалить это?"
        boo={modal}
        setModal={(e) => setModal(e)}
        _callback={(e) => deleteHandler(e)}
      />

      <div className="row">
        <div className="col-12">
          {ads.length > 0 ? (
            <Table
              headData={headData}
              renderHead={(item, index) => renderHead(item, index)}
              bodyData={ads}
              renderBody={(item, index) => renderBody(item, index)}
              pages={total}
              currPage={currpage}
              changePage={pageHandler}
              loading={loading}
            />
          ) : (
            <div className="my-3">
              <Alert severity="info">У вас пока нет объявлений</Alert>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Main;
